var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.61,
    height: 22.56,
    viewBox: "0 0 20.61 22.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS_FLUJO",
    "data-name": "ICONOS FLUJO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "closed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cerrado"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4,21.23c-1.94,0-2.53-.59-2.53-2.53v-.88c0-1.94.59-2.53,2.53-2.53h4.41c1.94,0,2.53.59,2.53,2.53v.88c0,1.94-.59,2.53-2.53,2.53Zm-1.87-3.41v.88c0,1.57.3,1.87,1.87,1.87h4.41c1.57,0,1.87-.3,1.87-1.87v-.88c0-1.57-.3-1.87-1.87-1.87H15.4C13.83,16,13.53,16.25,13.53,17.82Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.81,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.63,14.87v-.71c0-1,.31-2.39,3-2.39.45,0,2,0,2.62.88a2.94,2.94,0,0,1,.36,1c0,.08,0,.37.08,1,0,.26,0,.39-.07.47a.43.43,0,0,1-.51-.06.45.45,0,0,1-.1-.34c0-.3-.05-.59-.06-.88a1.85,1.85,0,0,0-.24-.86c-.28-.37-.87-.65-2.08-.65-1.92,0-2.31.74-2.31,1.86v.71a.34.34,0,0,1-.66,0Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.17,18.26a1.43,1.43,0,1,1,1.43,1.43A1.44,1.44,0,0,1,16.17,18.26Zm.66,0a.77.77,0,1,0,.77-.77A.78.78,0,0,0,16.83,18.26Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.81,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.49,5.2h2.09a.74.74,0,0,1,0,1.47H16.76A.75.75,0,0,1,16,5.83V2.38a.66.66,0,0,1,.73-.73.72.72,0,0,1,.73.73V5.2Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "lineas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36,13.69H4.85c-.07,0-.17,0-.21,0a.7.7,0,0,1-.2-.39.74.74,0,0,1,.2-.38c.05-.05.13,0,.19,0h7.25c.13,0,.23.15.23.38s-.09.38-.24.41H8.36Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7,10.73H4.82c-.09,0-.22,0-.29,0s-.27-.25-.27-.38.17-.28.28-.38.18,0,.26,0h10a.35.35,0,0,1,.32.38.37.37,0,0,1-.33.41H9.7Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64,7.51H4.77c-.35,0-.56-.15-.53-.41s.25-.38.53-.38h5.74c.36,0,.54.14.52.41s-.24.38-.52.38Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.49
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.29.51c.45,0,.68,0,1,0A7.41,7.41,0,0,1,19.17,2c1.87,1.54,2,4.06,2.2,6a13.37,13.37,0,0,1-.07,2.64.67.67,0,1,1-1.3,0V8.55c0-4.81-1.47-6.48-5.54-6.48H9C5,2.07,3.49,3.74,3.49,8.55v6.27C3.49,19.62,5,21.4,9,21.4H10.8c.32,0,.63.31.63.84s-.31.83-.63.83H9c-4.81,0-6.9-2.4-6.9-8.15V8.65c0-5.64,2.09-8,6.9-8C9.33.61,11,.55,14.29.51Z",
    transform: "translate(-2.13 -0.51)",
    fill: "{props.color}"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.46,22",
    transform: "translate(-2.13 -0.51)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88,17.54",
    transform: "translate(-2.13 -0.51)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.4d6443019d68b38d03907ef0c774f633.svg";
export { ForwardRef as ReactComponent };